// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const heron = defineModel({
  id: "heron",
  batchId: "standard",
  name: "Heron",
  tags: ["creature","heron","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly heron.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.004, 0.003, 0.13, 4), color: "#caa050", position: [0, 0.065, 0.018] },
      { geometry: new THREE.CylinderGeometry(0.004, 0.003, 0.13, 4), color: "#caa050", position: [0, 0.065, -0.018] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#8fa6b6", position: [0, 0.16, 0], scale: [1.4, 0.9, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.011, 0.08, 5), color: "#9cb2c0", position: [0.03, 0.22, 0], rotation: [0, 0, -0.4] },
      { geometry: new THREE.CylinderGeometry(0.007, 0.009, 0.06, 5), color: "#9cb2c0", position: [0.06, 0.27, 0], rotation: [0, 0, 0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#aebdc8", position: [0.05, 0.31, 0] },
      { geometry: new THREE.ConeGeometry(0.006, 0.045, 4), color: "#e0c038", position: [0.085, 0.305, 0], rotation: [0, 0, -1.3] },
      { geometry: new THREE.BoxGeometry(0.03, 0.004, 0.004), color: "#2a3038", position: [0.02, 0.325, 0] },
      { geometry: new THREE.ConeGeometry(0.018, 0.05, 4), color: "#7e95a5", position: [-0.05, 0.155, 0], rotation: [0, 0, 1.570796], scale: [1, 1, 0.5] },
    ],
  animations: [],
});
